// components/SkeletonResumeSection.jsx
import Skeleton from "react-loading-skeleton";

const SkeletonResumeSection = () => {
  return (
    <section className="timeline">
      {/* Section header */}
      <div className="title-wrapper flex items-center gap-3 mb-4">
        <div className="icon-box">
          <Skeleton circle width={32} height={32} />
        </div>
        <h3 className="h3">
          <Skeleton width={120} height={20} />
        </h3>
      </div>

      {/* Timeline items */}
      <ol className="timeline-list space-y-6">
        {Array(3)
          .fill(null)
          .map((_, idx) => (
            <li className="timeline-item" key={idx}>
              <h4 className="h4 timeline-item-title">
                <Skeleton width="60%" height={18} />
              </h4>
              <span>
                <Skeleton width={80} height={14} />
              </span>
              <p className="timeline-text mt-2">
                <Skeleton count={2} height={14} />
              </p>
            </li>
          ))}
      </ol>
    </section>
  );
};

export default SkeletonResumeSection;
